import { ClientList } from '@src/clients/domain/Client';
import { ClientsClient } from '@src/clients/services/ClientsClient';
import { useQuery } from '@tanstack/react-query';

export const useListAllWithClientAsBillTo = (
  clientId: string,
  open: boolean,
) => {
  const { data: clientAsBillToList = new ClientList([]) } =
    useQuery<ClientList>({
      queryKey: ['clients.listWithBillTo', clientId],
      queryFn: () => ClientsClient.listAllWithClientAsBillTo(clientId),
      enabled: open,
    });

  return {
    clientAsBillToList,
  };
};
